export default {
  title: 'Programadores',
  subtitle: 'Chaves de API, webhooks e histórico de entregas da sua integração com a API de parceiros.',
  no_account: 'Ainda não tem conta na API de parceiros — contacte a Foodamigos para ser criada.',
  no_account_manage: 'Ainda não há conta de API de Parceiro — crie uma para começar a emitir chaves.',
  buttons: {
    new_account: 'Nova conta',
    edit_account: 'Editar conta',
    docs: 'Documentação da API',
  },
  tabs: {
    api_keys: 'Chaves de API',
    webhooks: 'Webhooks',
    deliveries: 'Entregas',
  },
  toasts: {
    load_error: 'Não foi possível carregar as suas contas da API de parceiros.',
  },
};
